// 默认路由
const defaultRoutes = [
  {
    //登录
    path: '/login',
    name: 'login',
    meta: {
      title: '登录',
    },
    component: () => import('@/views/login/index'),
  },
  {
    //首页
    path: '/',
    name: 'admin',
    redirect: '/home',
    meta: {
      needLogin: true, //是否需要登录才能进入
    },
    component: () => import('@/views/index'),
    children: [
      {
        path: 'home',
        name: 'home',
        meta: {
          title: '米因健康AI后台',
          needLogin: true, //是否需要登录才能进入
        },
        component: () => import('@/views/home/index'),
      },
      {
        path: 'mainNews',
        name: 'mainNews',
        meta: {
          title: '消息通知',
          needLogin: true, //是否需要登录才能进入
        },
        component: () => import('@/views/information/index'),
      },
    ],
  },
  {
    //报告打印 - 查看报告
    path: '/reportPrint/lookReport',
    name: 'lookReport',
    meta: {
      title: '查看报告',
      needLogin: true, //是否需要登录才能进入
    },
    component: () => import('@/views/reportPrint/lookReport'),
  },
  {
    //报告打印 - 打印模板
    path: '/reportPrint/printTemplate',
    name: 'printTemplate',
    meta: {
      title: '报告打印',
      needLogin: true, //是否需要登录才能进入
    },
    component: () => import('@/views/reportPrint/printTemplate'),
  },
  {
    path: '/archives/detail',
    name: 'archivesDetail',
    meta: {
      title: 'AI银发健康评估服务-详情',
    },
    component: () => import('@/views/archives/detail'),
    children: [
      {
        path: '',
        name: 'archivesDetailIndex',
        meta: {
          title: 'AI银发健康评估服务-详情',
        },
        component: () => import('@/views/archives/details/index'),
      },
      {
        path: 'disease',
        name: 'archivesDetailDisease',
        meta: {
          title: 'AI银发健康评估服务-详情',
        },
        component: () => import('@/views/archives/details/disease'),
      },
      {
        path: 'health',
        name: 'archivesDetailHealth',
        meta: {
          title: 'AI银发健康评估服务-详情',
        },
        component: () => import('@/views/archives/details/health'),
      },
      {
        path: 'body',
        name: 'archivesDetailBody',
        meta: {
          title: 'AI银发健康评估服务-详情',
        },
        component: () => import('@/views/archives/details/body'),
      },
      {
        path: 'fb',
        name: 'archivesDetailFb',
        meta: {
          title: 'AI银发健康评估服务-详情',
        },
        component: () => import('@/views/archives/details/fb'),
      },
    ],
  },

  {
    //所有不存在路由进入login
    path: '*',
    name: '404',
    redirect: '/login',
  },
]

export default defaultRoutes.concat()
